import './DateHeaderLabel.scss';

import React from 'react';

import bem from '../../utils/bem';

interface DateHeaderLabelProps {
  label: string;
  subLabel?: string;
  dataTestid?: string;
}

const [block, element] = bem('date-header-label');

const DateHeaderLabel = ({ label, subLabel, dataTestid }: DateHeaderLabelProps): JSX.Element => {
  return (
    <div className={block()} data-testid={dataTestid}>
      <div>{label}</div>
      {subLabel && <span className={element('sub-label')}>{subLabel}</span>}
    </div>
  );
};

export default DateHeaderLabel;
